//# sourceMappingURL=rate_limits.mjs.map
/// <reference types="./rate_limits.d.mts" />
import * as $ai_config from "../../../../data_types/data/ai_config.mjs";
import * as $llm_capacity from "../../../../data_types/data/llm_capacity.mjs";
import { CallFailed, NotSent, Read } from "../../../../data_types/data/llm_capacity.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $callout from "../../../../ds/ds/components/callout.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $loader from "../../../../ds/ds/components/loader.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $calendar from "../../../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import { Ok, toList } from "../../../gleam.mjs";

function status_label(content, status) {
  return $label.label(
    toList([status, $label.capitalize(false), $label.content(content)]),
  );
}

function headers_status(rate_limit) {
  let $ = rate_limit.status;
  if ($ instanceof Read) {
    return status_label("Read", $label.success());
  } else if ($ instanceof NotSent) {
    return status_label("Not sent", $label.neutral());
  } else {
    let error = $.error;
    return $l.column(
      toList([$l.gap(4)]),
      toList([]),
      toList([
        status_label("Call failed", $label.error()),
        $typography.text($typography.xs, $typography.regular, error),
      ]),
    );
  }
}

export function thousands(value) {
  let _pipe = $int.to_string(value);
  let _pipe$1 = $string.to_graphemes(_pipe);
  let _pipe$2 = $list.reverse(_pipe$1);
  let _pipe$3 = $list.sized_chunk(_pipe$2, 3);
  let _pipe$4 = $list.map(_pipe$3, $list.reverse);
  let _pipe$5 = $list.reverse(_pipe$4);
  let _pipe$6 = $list.map(_pipe$5, $string.concat);
  return $string.join(_pipe$6, ",");
}

function limit(value) {
  if (value instanceof Some) {
    let value$1 = value[0];
    return thousands(value$1);
  } else {
    return "–";
  }
}

function provider_name(rate_limit) {
  let _pipe = $ai_config.model_from_string(rate_limit.model_alias);
  return $result.map(_pipe, $ai_config.provider_name);
}

function sort_by_provider(rate_limits) {
  return $list.sort(
    rate_limits,
    (a, b) => {
      let provider = (r) => { return $result.unwrap(provider_name(r), ""); };
      let _pipe = $string.compare(provider(a), provider(b));
      return $order.lazy_break_tie(
        _pipe,
        () => { return $string.compare(a.deployment_id, b.deployment_id); },
      );
    },
  );
}

function rate_limits_table(rate_limits) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          (() => {
            let _pipe = $table.header("Deployment");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("Model");
            return $table.fraction(_pipe, 2);
          })(),
          (() => {
            let _pipe = $table.header("RPM");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("TPM");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Input TPM");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Output TPM");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Headers");
            return $table.fraction(_pipe, 2);
          })(),
        ]),
      ),
      $table.body(
        $list.map(
          sort_by_provider(rate_limits),
          (rate_limit) => {
            let limits = rate_limit.limits;
            let _pipe = $table.row(
              toList([
                $table.cell(
                  $l.column(
                    toList([$l.gap(2)]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        rate_limit.deployment_id,
                      ),
                      (() => {
                        let $ = provider_name(rate_limit);
                        if ($ instanceof Ok) {
                          let provider = $[0];
                          return $typography.text(
                            $typography.xs,
                            $typography.regular,
                            provider,
                          );
                        } else {
                          return status_label("Unknown model", $label.neutral());
                        }
                      })(),
                    ]),
                  ),
                ),
                $table.cell(
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    rate_limit.model_alias,
                  ),
                ),
                $table.cell(
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    limit(limits.rpm),
                  ),
                ),
                $table.cell(
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    limit(limits.tpm),
                  ),
                ),
                $table.cell(
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    limit(limits.itpm),
                  ),
                ),
                $table.cell(
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    limit(limits.otpm),
                  ),
                ),
                $table.cell(headers_status(rate_limit)),
              ]),
            );
            return $table.row_id(_pipe, rate_limit.deployment_id);
          },
        ),
      ),
    ]),
  );
}

function status_counts(rate_limits) {
  let count = (keep) => {
    return $list.count(rate_limits, (r) => { return keep(r.status); });
  };
  let read = count((status) => { return status instanceof Read; });
  let not_sent = count((status) => { return status instanceof NotSent; });
  let failed = ($list.length(rate_limits) - read) - not_sent;
  return $l.row(
    toList([$l.gap(8)]),
    toList([]),
    toList([
      status_label(("Read (" + $int.to_string(read)) + ")", $label.success()),
      status_label(
        ("Not sent (" + $int.to_string(not_sent)) + ")",
        $label.neutral(),
      ),
      status_label(
        ("Call failed (" + $int.to_string(failed)) + ")",
        $label.error(),
      ),
    ]),
  );
}

export function view(rate_limits) {
  if (rate_limits instanceof $remote.NotLoaded) {
    return $loader.loader(toList(["Loading the rate limits…"]));
  } else if (rate_limits instanceof $remote.Loading) {
    return $loader.loader(toList(["Loading the rate limits…"]));
  } else if (rate_limits instanceof $remote.Errored) {
    let error = rate_limits[0];
    return $callout.error(
      toList([]),
      toList([$callout.content(toList([]), toList([$h.text(error)]))]),
    );
  } else {
    let rate_limits$1 = rate_limits[0];
    return $l.column(
      toList([$l.gap(16)]),
      toList([]),
      toList([
        status_counts(rate_limits$1),
        rate_limits_table(rate_limits$1),
        $typography.text(
          $typography.sm,
          $typography.regular,
          (((("Refresh limits asks nabu to send one short request to every " + "deployment in its model registry and saves the rate-limit headers ") + "that come back. Read: the provider sent its limits. Not sent: ") + "this provider never sends them (Bedrock, Gemini). Call failed: ") + "the request itself failed. Limits only change when a provider ") + "moves the account to another tier.",
        ),
      ]),
    );
  }
}

export function local_time_text(time) {
  let _pipe = $timestamp.to_rfc3339(time, $calendar.local_offset());
  let _pipe$1 = $string.slice(_pipe, 0, 16);
  return $string.replace(_pipe$1, "T", " ");
}
